<template>
    <div class="container">
        <CompleteSectionRegister v-show="showPopUp" @hidePopUp="hideCreateCompSection"></CompleteSectionRegister>
        <button class="btn btn-danger float-end" @click.prevent="showCreateCompSection()">Crear nuevo tramo
            completo</button>
        <div class="container table-responsive mx-auto">
            <table class="table">
                <tbody>
                    <tr>
                        <th>Clasificación</th>
                        <th>Presentación</th>
                        <th>Espcificación</th>
                        <th>Dimensión</th>
                        <th>Precio asociado</th>
                        <th colspan="2"></th>
                    </tr>
                    <tr v-for="sheetDim in sheetDimensions" :key="sheetDim.id">
                        <td>{{ sheetDim.sheetType }}</td>
                        <td>{{ sheetDim.presentation }}</td>
                        <td>{{ sheetDim.specification }}</td>
                        <td>{{ sheetDim.dimensions }}</td>
                        <td>{{ sheetDim.priceId["value"] }}</td>
                        <td>
                            <div>
                                <button class="btn btn-danger" @click.prevent="editCompSection(sheetDim.id)">
                                    Editar
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_BACKEND;
import CompleteSectionRegister from "@/components/Admin/CompleteSections/RegisterCompleteSectionsComponent.vue";
export default {
    data() {
        return {
            sheetDimensions: [],
            showPopUp: false,
        };
    },
    components: {
        CompleteSectionRegister,
    },
    methods: {
        editCompSection(priceId) {
            //console.log(priceId);
            this.$emit("sendCompleteSectionId", priceId);
        },
        showCreateCompSection() {
            this.showPopUp = true;
        },
        hideCreateCompSection(data) {
            this.showPopUp = data;
        },
    },
    beforeMount() {
        axios
            .get(RUTA_SERVIDOR + "api/sheet/dimension/list", {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),
                },
            })
            .then((res) => (this.sheetDimensions = res.data))
            .catch((err) => console.log(`There has been an error ${err}`));
    },

};
</script>